// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // <--- ADD THIS LINE. THIS IS THE MOST CRITICAL FIX!
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);